import store from "../../redux/store";

const bodyScrollHandler = () => {
    const state = store.getState();
    if (state.visible) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = 'initial';
    }
};

export default bodyScrollHandler;